// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Swaziland from '../_raw/flag/icon_flag_swaziland.png';

export default () => <img src={Swaziland} alt="Swaziland" />;
